import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useGetPostingDetails } from '../../../../../domain/PermanentJobs';
import { getUser } from '../../../../../services/users';

export const useProfileInfo = ({ officeId, jobId }) => {
  const { data: currentOffice, isLoading: isOfficeQueryLoading } = useQuery({
    queryKey: ['getOfficeDetail', officeId],
    queryFn: () => getUser(officeId),
    enabled: !!officeId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const postingDetailsOptions = useMemo(
    () => ({
      enabled: !!jobId,
    }),
    [jobId],
  );

  const { data: currentJobPosting, isInitialLoading: isJobPostingQueryLoading } =
    useGetPostingDetails(
      {
        postingId: jobId,
      },
      postingDetailsOptions,
    );

  return {
    user: currentOffice?.user,
    job: currentJobPosting,
    isLoading: isOfficeQueryLoading || isJobPostingQueryLoading,
  };
};
